function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M227.068 454.851C166.479 454.851 109.491 431.255 66.6018 388.406C23.7532 345.558 0.157158 288.57 0.157158 227.937C0.157158 167.348 23.7532 110.36 66.6018 67.4741C109.494 24.6222 166.482 1.02612 227.068 1.02612C282.245 1.02612 335.42 21.0479 376.801 57.4061C378.89 59.2437 379.099 62.4283 377.261 64.5179C375.424 66.6074 372.239 66.8123 370.149 64.9781C330.61 30.2357 279.796 11.1042 227.068 11.1042C169.173 11.1042 114.714 33.6521 73.727 74.5993C32.7832 115.58 10.2352 170.038 10.2352 227.937C10.2352 285.876 32.7832 340.331 73.727 381.278C114.711 422.222 169.169 444.77 227.068 444.77C268.287 444.77 308.351 433.187 342.922 411.277C403.682 372.795 437.938 297.566 471.068 224.813C504.51 151.367 539.091 75.4223 601.286 36.0776C637.537 13.1467 679.462 1.02612 722.532 1.02612C783.161 1.02612 840.15 24.6222 882.998 67.4707C899.012 83.4848 912.48 101.696 923.038 121.593C924.342 124.052 923.404 127.103 920.945 128.406C918.486 129.706 915.436 128.772 914.133 126.316C904.044 107.299 891.171 89.8978 875.869 74.5959C834.926 33.6521 780.467 11.1042 722.532 11.1042C681.373 11.1042 641.31 22.6872 606.675 44.5969C547.019 82.3359 513.07 156.89 480.242 228.992C446.504 303.089 411.614 379.709 348.32 419.793C312.13 442.727 270.205 454.851 227.068 454.851Z",
  fill: "url(#paint30_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.27 0.998871C1273.86 0.998871 1330.85 24.5949 1373.74 67.4435C1416.59 110.292 1440.18 167.28 1440.18 227.913C1440.18 288.502 1416.59 345.49 1373.74 388.376C1330.85 431.228 1273.86 454.824 1213.27 454.824C1158.1 454.824 1104.92 434.802 1063.54 398.444C1061.45 396.606 1061.24 393.422 1063.08 391.332C1064.92 389.242 1068.1 389.038 1070.19 390.872C1109.73 425.614 1160.55 444.746 1213.27 444.746C1271.17 444.746 1325.63 422.198 1366.61 381.251C1407.56 340.27 1430.11 285.811 1430.11 227.913C1430.11 169.974 1407.56 115.519 1366.61 74.572C1325.63 33.6282 1271.17 11.0803 1213.27 11.0803C1172.05 11.0803 1131.99 22.6633 1097.42 44.573C1036.66 83.0544 1002.4 158.284 969.274 231.037C935.831 304.483 901.25 380.428 839.055 419.772C802.805 442.703 760.88 454.824 717.81 454.824C657.18 454.824 600.192 431.228 557.343 388.379C541.329 372.365 527.862 354.154 517.303 334.257C516 331.798 516.937 328.747 519.396 327.444C521.855 326.144 524.906 327.078 526.209 329.533C536.297 348.551 549.17 365.952 564.472 381.254C605.416 422.198 659.874 444.746 717.81 444.746C758.968 444.746 799.032 433.163 833.667 411.253C893.322 373.514 927.272 298.96 960.099 226.858C993.837 152.761 1028.73 76.1408 1092.02 36.0571C1128.21 13.1228 1170.14 0.998871 1213.27 0.998871Z",
  fill: "url(#paint31_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.27 0.998871C1273.86 0.998871 1330.85 24.5949 1373.74 67.4435C1416.59 110.292 1440.18 167.28 1440.18 227.913C1440.18 288.502 1416.59 345.49 1373.74 388.376C1330.85 431.228 1273.86 454.824 1213.27 454.824C1158.1 454.824 1104.92 434.802 1063.54 398.444C1061.45 396.606 1061.24 393.422 1063.08 391.332C1064.92 389.242 1068.1 389.038 1070.19 390.872C1109.73 425.614 1160.55 444.746 1213.27 444.746C1271.17 444.746 1325.63 422.198 1366.61 381.251C1407.56 340.27 1430.11 285.811 1430.11 227.913C1430.11 169.974 1407.56 115.519 1366.61 74.572C1325.63 33.6282 1271.17 11.0803 1213.27 11.0803C1172.05 11.0803 1131.99 22.6633 1097.42 44.573C1036.66 83.0544 1002.4 158.284 969.274 231.037C935.831 304.483 901.25 380.428 839.055 419.772C802.805 442.703 760.88 454.824 717.81 454.824C657.18 454.824 600.192 431.228 557.343 388.379C541.329 372.365 527.862 354.154 517.303 334.257C516 331.798 516.937 328.747 519.396 327.444C521.855 326.144 524.906 327.078 526.209 329.533C536.297 348.551 549.17 365.952 564.472 381.254C605.416 422.198 659.874 444.746 717.81 444.746C758.968 444.746 799.032 433.163 833.667 411.253C893.322 373.514 927.272 298.96 960.099 226.858C993.837 152.761 1028.73 76.1408 1092.02 36.0571C1128.21 13.1228 1170.14 0.998871 1213.27 0.998871Z",
  fill: "url(#paint32_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M382.946 49.6207C389.141 55.251 389.598 64.8386 383.967 71.0299C378.337 77.2245 368.749 77.6814 362.558 72.0511C356.363 66.4208 355.907 56.8366 361.537 50.642C367.167 44.4473 376.755 43.9904 382.946 49.6207Z",
  fill: "url(#paint33_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M904.54 130.195C908.316 137.663 917.437 140.659 924.905 136.88C932.373 133.104 935.369 123.983 931.59 116.516C927.814 109.048 918.693 106.054 911.226 109.83C903.758 113.606 900.765 122.724 904.54 130.195Z",
  fill: "url(#paint34_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear",
  x1: 0.157158,
  y1: 227.938,
  x2: 929.942,
  y2: 227.938,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear",
  x1: 1440.18,
  y1: 227.912,
  x2: 510.399,
  y2: 227.912,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear",
  x1: 1445.5,
  y1: 227.912,
  x2: 516.714,
  y2: 227.912,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.369792,
  stopColor: "#FF36BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.484375,
  stopColor: "#944CDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.744792,
  stopColor: "#84848B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.911458,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear",
  x1: 0.151616,
  y1: 60.8359,
  x2: 929.945,
  y2: 60.8359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear",
  x1: 0.157195,
  y1: 123.354,
  x2: 929.944,
  y2: 123.354,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})));

function SvgRoadmapBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1441 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBg1);
export default __webpack_public_path__ + "static/media/roadmap-bg-1.5ab8b1d1.svg";
export { ForwardRef as ReactComponent };